import PropTypes from 'prop-types';
import React from 'react';
import SearchField from './SearchField';

export default function renderSearchField({ input, meta: { touched, error, warning }, ...args }) {
  const validationMessage = touched ? error || warning : null;
  const isValid = !(error || warning);

  return (
    <SearchField validationMessage={validationMessage} isValid={isValid} {...args} {...input} />
  );
}

renderSearchField.propTypes = {
  input: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
};
